var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropdown",staticClass:"a-dropdown"},[_vm._t("trigger",null,{"toggleDropdown":_vm.toggleDropdown,"isDropdownOpen":_vm.isDropdownOpen}),_c('portal',{attrs:{"to":"dropdown"}},[_c('div',{staticClass:"a-dropdown__content",style:(_vm.contentStyles),attrs:{"id":_vm.computedId}},[_vm._t("default")],2)])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }